import React, { useEffect, useMemo, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';
import { useGetBulkUploadTemplateConfigsHandler } from '../dataHandlers/getBulkUploadTemplateConfigsHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const BulkUploadTemplateSelector = ({ onSelect, category, subCategory }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const { bulkUpload } = useTranslatedMessages();
  const templateNameLabel = bulkUpload?.template_selector?.template_name_label ?? 'Template Name';
  const { templateConfigs } = useGetBulkUploadTemplateConfigsHandler({ category, subCategory });

  useEffect(() => {
    setSelectedTemplate(null);
  }, [category, subCategory]);

  const templateOptions = useMemo(
    () =>
      templateConfigs.map((item) => ({
        key: item.templateName,
        value: item.templateName,
        label: item.displayName ?? item.templateName,
      })),
    [templateConfigs],
  );

  const handleChange = (event, value) => {
    setSelectedTemplate(value);
    onSelect(value?.value);
  };

  return (
    <Autocomplete
      id="template-selector"
      options={templateOptions}
      getOptionLabel={(option) => option?.label ?? ''}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      renderInput={(params) => <TextField {...params} label={templateNameLabel} />}
      onChange={handleChange}
      value={selectedTemplate}
    />
  );
};

export default BulkUploadTemplateSelector;
